/* eslint-disable import/prefer-default-export */
import DashInteractiveGraphviz from './components/DashInteractiveGraphviz.react';

export {
    DashInteractiveGraphviz
};
